/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Switch_TitleInputs */

const en_fc_vs_switch_title = /** @type {(inputs: Fc_Vs_Switch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switching from Premiere Pro`)
};

/**
* | output |
* | --- |
* | "Switching from Premiere Pro" |
*
* @param {Fc_Vs_Switch_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_switch_title = /** @type {((inputs?: Fc_Vs_Switch_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Switch_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_switch_title(inputs)
});
export { fc_vs_switch_title as "fc.vs.switch.title" }